import { MultisignTransfer } from '../transfer/multisign.transfer';

export const CATAPULT_TRANSFER_PROVIDERS = [
  MultisignTransfer
];
